import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import baseUrl from "../../API/BaseUrl";

const initialState = {
    AddCoupon: [],
    AllCoupon: [],
    deleteCoupon: [],
    editCoupon: [],
    isLoading: true,
    isSuccess: false,
    errorMessage: "",
};

// Add New Coupon
export const AddNewCoupon = createAsyncThunk(
    "Coupon/AddNew",
    async (data) => {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                },
            }
            const res = await baseUrl.post("/api/v1/coupons", data, config);
            return res.data;
        } catch (error) {
            return error;
        }
    }
);

// get all Coupons
export const getAllCoupons = createAsyncThunk(
    "Coupon/getAll",
    async (querySelector) => {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                },
            }
            const res = await baseUrl.get(`/api/v1/coupons?${querySelector}`, config);
            return res.data;
        } catch (error) {
            return error;
        }
    }
);

// Edit Coupon
export const EditCoupon = createAsyncThunk(
    "Coupon/Editone",
    async ({id,data}) => {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                },
            }
            const res = await baseUrl.put(`/api/v1/coupons/${id}`,data, config);
            return res.data;
        } catch (error) {
            return error;
        }
    }
);

// Delete Coupon
export const DeleteCoupon = createAsyncThunk(
    "Coupon/deleteone",
    async (id) => {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                },
            }
            const res = await baseUrl.delete(`/api/v1/coupons/${id}`, config);
            return res.data;
        } catch (error) {
            return error;
        }
    }
);




const CouponSlice = createSlice({
    name: "Coupon",
    initialState: initialState,
    reducers: {},
    extraReducers: {
        [AddNewCoupon.pending]: (state, action) => {
            state.isLoading = true;
        },
        [AddNewCoupon.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.AddCoupon = action.payload;
        },
        [AddNewCoupon.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload;
        },
        [getAllCoupons.pending]: (state, action) => {
            state.isLoading = true;
        },
        [getAllCoupons.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.AllCoupon = action.payload;
        },
        [getAllCoupons.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload;
        },
        [DeleteCoupon.pending]: (state, action) => {
            state.isLoading = true;
        },
        [DeleteCoupon.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.deleteCoupon = action.payload;
        },
        [DeleteCoupon.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload;
        },
        [EditCoupon.pending]: (state, action) => {
            state.isLoading = true;
        },
        [EditCoupon.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.editCoupon = action.payload;
        },
        [EditCoupon.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload;
        }
    },
});

export default CouponSlice.reducer;
